export default "__VITE_ASSET__93a1c35e__"